module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C1177"
  }, [_c('span', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("P")]), _vm._v("ART ONE")]), _vm._v(" "), _c('p', {
    staticClass: "C1317"
  }, [_vm._v("Framing Right and Wrong")]), _vm._v(" "), _c('p', {
    staticClass: "C1170"
  }, [_vm._v("The construction of categories is the great beginning of moral teaching.")]), _vm._v(" "), _c('p', {
    staticClass: "C1170a"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("MARK D. JORDAN, "), _c('em', [_vm._v("THE INVENTION OF SODOMY ")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60fde023","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/07_PART_ONE.vue
// module id = 75
// module chunks = 0